import { UserRole } from '../../../shared/enums';

const PermissionsOfQuillCommentBox = {
  SeeResolveCommentButton: [UserRole.ADMIN, UserRole.EDITOR],
  SeeDeleteCommentButton: [UserRole.ADMIN],
  SeeEditCommentButton: [UserRole.ADMIN],
  SeeUpdateCommentButton: [UserRole.ADMIN],
  SeeEditReplyButton: [UserRole.ADMIN],
  SeeUpdateReplyButton: [UserRole.ADMIN],
};

export default PermissionsOfQuillCommentBox;
